import { EntryFormEnum } from "~~/enums/entryFormEnum";
import { Partner } from "~~/enums/partner";

export const useAnimaGetAvailableFdi = async (order_id?: string) => {
	try {
		return await useGet(
			`/partner_integration/${Partner.ANIMA}/available_fdi/${order_id}`,
		);
	} catch (e) {
		console.log("e", e);
		return {
				"data": {
					"available_fdis":[
						EntryFormEnum.ENEM,
						EntryFormEnum.ENTRADA_SIMPLIFICADA,
						EntryFormEnum.SEGUNDA_GRADUACAO,
						EntryFormEnum.TRANSFERENCIA,
						EntryFormEnum.VESTIBULAR_TRADICIONAL
					],
					"enem_score":null
				}
			};
	}
};
export const useAnimaGetSubscriptionLink = async (
	ies_id: string,
	id_inscricao: string,
	fdi_slug: string,
	cod_concurso: string,
	ies_slug: string,
	cpf: string
) => {

  const queryParameters: string = useQueryString({
	ies_id: ies_id,
    id_inscricao: id_inscricao,
    fdi_slug: fdi_slug,
    cod_concurso: cod_concurso,
    ies_slug: ies_slug,
    cpf: cpf,
  });

	return await useGet(
		`/partner_integration/${Partner.ANIMA}/generate-link?${queryParameters}`,
	);
};

export const useSaveCoverLetter = async (payload: any) => {
	return await usePost(
		`/partner_integration/${Partner.ANIMA}/cover-letter/save`, payload
	);
};

export const useSendCoverLetterMessage = async (order_id: string) => {
	return await useGet(
		`/partner_integration/${Partner.ANIMA}/cover-letter/send-message?order_id=${order_id}`
	);
};

export const useCheckCoverLetter = async (payload: any) => {
	return await useGet(
		`/partner_integration/${Partner.ANIMA}/cover-letter/get-by-status?status=pending&entity_key=${payload.entity_key}&entity_value=${payload.entity_value}&birthday=${payload.birthday}`, payload
	);
};